import { OpenPresetModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";
import { PresetsComponentsEnum } from "@modules/+new/shared/universal-modal/entities/presets-components.enum";
import { SuccessComponent } from "./success.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { SuccessData } from "./entities/success-data.interface";

export const SuccessPresetDefinition: OpenPresetModalDefinition<SuccessData> = {
	component: SuccessComponent,
	options: {
		wrap: false,
		size: ModalSizes.lg,
		showCancel: false,
		showPrevious: false,
		cancelKey: "close",
		isPreset: PresetsComponentsEnum.confirm
	}
};
